module.exports = __webpack_public_path__ + "static/img/iconMrWorld.9427fd8.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconMrWorld.svg
// module id = XwSl
// module chunks = 1